
interface PassConfig {
  passLetterMin?: number | null;
  passLowerMin?: number | null;
  passMinLength?: number | null;
  passNumMin?: number | null;
  passOtherMim?: number | null;
  passUpperMim?: number | null;
}
interface ConfigParams {
  statu?: boolean;
  message?: string;
}

const passConfig = (option: PassConfig, str: string) => {
  if(!option || Object.prototype.toString.call(option) !== '[object Object]') {
    return [];
  }

  const optionKeys = ['passLetterMin', 'passLowerMin', 'passMinLength', 'passNumMin', 'passOtherMim', 'passUpperMim'];
  for (let el of optionKeys) {
    if (!option.hasOwnProperty(el)) {
      return [];
    }
  }

  const {passLetterMin, passLowerMin, passMinLength, passNumMin, passOtherMim, passUpperMim} = option;

  let letterMacth = {}, 
    lowerMacth = {},
    lengthMatch = {},
    numMacth = {},
    otherMatch = {},
    upperMach = {};
  let configArr = [];

  if (!str) {
    str = '';
  }
  
  if (passLetterMin) {
    let match = str.match(/[A-Za-z]/g);
    let statu = false;
    if (match) {
      statu = match.length >= passLetterMin;
    }
    letterMacth['statu'] = statu;
    letterMacth['message'] = `至少包含${passLetterMin}个字母`;
    configArr.push(letterMacth);
  }

  if (passLowerMin) {
    let match = str.match(/[a-z]/g);
    let statu = false;
    if (match) {
      statu = match.length >= passLowerMin;
    }
    lowerMacth['statu'] = statu;
    lowerMacth['message'] = `至少包含${passLowerMin}个小写写字母`;
    configArr.push(lowerMacth);
  }

  if (passMinLength) {
    let statu = (str.length >= passMinLength);
    lengthMatch['statu'] = statu;
    lengthMatch['message'] = `最小长度为${passMinLength}`;
    configArr.push(lengthMatch);
  }

  if (passNumMin) {
    let match = str.match(/\d/g);
    let statu = false;
    if (match) {
      statu = match.length >= passNumMin;
    }
    numMacth['statu'] = statu;
    numMacth['message'] = `至少包含${passNumMin}个数字`;
    configArr.push(numMacth);
  }

  if (passOtherMim) {
    let match = str.match(/[\!@#\$%\^\&\*\(\)_\+\-\=\[\]\{\}\|']/g);
    let statu = false;
    if (match) {
      statu = match.length >= passOtherMim;
    }
    otherMatch['statu'] = statu;
    otherMatch['message'] = `至少包含${passOtherMim}个特殊字符`;
    configArr.push(otherMatch);
  }

  if (passUpperMim) {
    let match = str.match(/[A-Z]/g);
    let statu = false;
    if (match) {
      statu = match.length >= passUpperMim;
    }
    upperMach['statu'] = statu;
    upperMach['message'] = `至少包含${passUpperMim}个大写字母`;
    configArr.push(upperMach);
  }

  return configArr;
};

export default passConfig;


// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/utils/PassConfig/index.ts